import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';

import { SocialProofComponent } from '@valk-nx/components/ui-social-proof/src/lib/social-proof';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [AngularSvgIconModule, CommonModule, SocialProofComponent],
	selector: 'vp-rating',
	templateUrl: './rating.html',
})
export class RatingComponent extends BaseDirective {
	private readonly viewport = inject(ViewPortService);

	score = input<number>(1);
	numberOfRatings = input<number>(0);
	isHorizontal = input<boolean>();

	readonly isMobile$: Observable<boolean>;

	constructor() {
		super();
		this.isMobile$ = this.viewport.isMobile$;
	}
}
